<template lang="pug">
  div
    slot(name='children'
        v-bind:genericParentContainer='innerContainer',
        v-bind:parentContainer='outerContainer')
    //slot(name="child",
        v-bind:parentContainer='container')
      //p am sprite {{transform.id}}

    slot(v-if='rendered',name='holder',
        v-bind:holder='holder',
        v-bind:transform='transform',
        v-bind:depth='depth',
        v-bind:context='context',
        v-bind:innerContainer='innerContainer',
        v-bind:outerContainer='outerContainer',
        v-bind:displayObject='sprite.sprite')

</template>
<script>
import { makeTilingSprite, moveTilingSprite } from '@/play/game/util.js';

export default {
  props:{
    transform: {
      type: Object,
      required: true
    },
    innerContainer: {
      type: Object,
      required: true
    },
    outerContainer: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    holder: {
      type: Object,
      required: true
    },
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const sprite = new TilingSprite(this.renderTools, this.innerContainer, this.transform, component, this.holder);
    return {
      sprite,
      component,
      rendered: false
    }
  },
  components:{
  },
  mounted() {
    this.sprite.events.on("loaded", () => {
      console.log('loaded sprite execute event');
      this.rendered = true;
      this.$emit("loaded");
      this.renderTools.executeAutoScaleEvent(this.transform, this.holder);
    });
    this.renderTools.addToEnterBatch(this.sprite);
    this.renderTools.addToUpdateBatch(this.sprite);
    this.renderTools.addToRunBatch( () => {
      this.holder.addSceneObject(this.component.id, this.sprite);
    });
  },
  methods:{
  },
  beforeDestroy() {
    this.sprite.events.off("loaded");
    this.renderTools.addToExitBatch(this.sprite);
    this.holder.removeSceneObject(this.component.id, this.sprite);
  },
  computed:{
  },
  watch:{
    'component.sprite'() {
      this.renderTools.addToUpdateBatch(this.sprite);
    },
    'component.offsetx'() {
      this.renderTools.addToUpdateBatch(this.sprite);
    },
    'component.offsety'() {
      this.renderTools.addToUpdateBatch(this.sprite);
    },
    'component.sizex'() {
      this.renderTools.addToUpdateBatch(this.sprite);
    },
    'component.sizey'() {
      this.renderTools.addToUpdateBatch(this.sprite);
    }
  }
}

import Loader from '@/edit/loader.js';
import EventEmitter from 'eventemitter3';

function TilingSprite(renderTools, parentContainer, transform, data, holder) {
  this.parentContainer = parentContainer;
  this.renderTools = renderTools;
  this.transform = transform;
  this.alpha = 1;
  this.events = new EventEmitter();
  this.loading = true;
  this.data = data;
  this.sprite = new PIXI.Sprite();
  this.holder = holder;
  this.lastSprite = data.sprite;
  if (data.firstLoad) {
    this.lastSprite = null;
    delete data.firstLoad;
  }
}

TilingSprite.prototype.waiting = function () {
  if (!this.myContainer) {
    return;
  }
  if (this.destroyed) {
    return;
  }

  if (!this.loading) {
  } else {
    this.renderTools.addToWaitBatch(this.waiting.bind(this));
  }
}

TilingSprite.prototype.enter = function () {
  this.sprite.anchor.x = 0.5;
  this.sprite.anchor.y = 0.5;
  if (this.transform.transform.anchor) {
    this.sprite.anchor.set(
      this.transform.transform.anchor.x,
      this.transform.transform.anchor.y,
    )
  }


  //this.renderTools.addToWaitBatch(this.waiting.bind(this));

  const rotation = this.transform.transform.rotation;

  const scale = this.transform.transform.scale;

  //this.myContainer = new PIXI.Container();
  this.myContainer = this.parentContainer;

  this.myContainer.addChild(this.sprite);
  //this.parentContainer.addChild(this.myContainer);

  //this.myContainer.scale.x = 1;
  //this.myContainer.scale.y = 1;

}
TilingSprite.prototype.justLoaded = function (texture) {
  if (this.data.sprite !== this.lastSprite) {
    const textureWidth = texture.width;
    const textureHeight = texture.height;

    const aspect = textureWidth / textureHeight;
    this.data.aspect = aspect;

    this.transform.transform.localScale.x = textureWidth / (1920/16) ;
    this.transform.transform.localScale.y = textureHeight / (1080/9) ;

    const layerId = this.transform.transform.layer;
    const layer = this.renderTools.layers[layerId];
    if (layer && layer.gridx) {
      const {x,y} = this.transform.transform.localScale;
      if (x > y) {
        const aspect = x/y;
        this.transform.transform.localScale.x = layer.gridy * aspect;
        this.transform.transform.localScale.y = layer.gridy;
      } else {
        const aspect = y/x;
        this.transform.transform.localScale.x = layer.gridx;
        this.transform.transform.localScale.y = layer.gridx * aspect;
      }
      const xx = this.transform.transform.pos.x;
      const yy = this.transform.transform.pos.y;
      this.transform.transform.zIndex = Math.floor(-yy+100) * 200 + Math.floor(xx+100);
    }


    this.lastSprite = this.data.sprite;
    this.renderTools.addToRunBatch( () => {
      this.renderTools.addToUpdateBatch(this.holder);
      this.renderTools.addToRunBatch( () => {
        this.renderTools.addToUpdateBatch(this);
      });
    });
  }

}

TilingSprite.prototype.getSquare = function () {
  const x = this.transform.transform.scale.x;
  const y = this.transform.transform.scale.y;
  return {
    x1:-x/2,
    x2:x/2,
    y1:-y/2,
    y2:y/2
  }
}
TilingSprite.prototype.getScaleThingy = function () {
  return this.transform.transform.scale;
}
TilingSprite.prototype.update = function () {
  console.log('TS update');
  //if (!this.myContainer || !this.myContainer.position) {
    //return;
  //}
  //this.myContainer.x = 0;
  //this.myContainer.y = 0;
  //this.myContainer.scale.x = 1;
  //this.myContainer.scale.y = 1;

  //TODO: fix this.myContainer.alpha = this.alpha;

  if (this.transform.transform.anchor) {
    const sprite = this.sprite;
    sprite.anchor.set(
      this.transform.transform.anchor.x,
      this.transform.transform.anchor.y,
    )
  }

  if (this.currentImg !== this.data.sprite) {
    console.log('le load image');
    this.loadImage();
    this.renderTools.addToWaitBatch(this.waiting.bind(this));
  } else {
    if (this.tilingSprite) {
      makeTilingSprite(this.data, this.tilingTexture, this.transform.transform, 0.5, 0.5, this.tilingSprite);
      moveTilingSprite(this.data, this.tilingSprite, {x:0,y:0}, this.width, this.height);
    }

  }


}
TilingSprite.prototype.exit = function () {
  this.destroyed = true;
  if (this.myContainer) {
    this.myContainer.destroy({
      children:true,
      texture:false
    })
  }

  if (this.parentContainer) {
    this.parentContainer.removeChild(this.myContainer);
  }
  this.myContainer = null;

  if (this.sprite) {
    const sprite = this.sprite;
    try {
      sprite.destroy();
    } catch (e) {
    }
  }
}


TilingSprite.prototype.getUrl = function (img) {
  return this.renderTools.makeImageUrl(img);
}

TilingSprite.prototype.loadImage = function () {
  this.loading = true;
  console.log('tile load image');
  //this.renderTools.addToUpdateBatch(this);
  //this.renderTools.addToWaitBatch(this.waiting.bind(this));
  if (!this.data.atlas) {
    const spriteToLoad = this.data.sprite;
    const url = this.getUrl(spriteToLoad);
    this.currentImg = this.data.sprite;
    Loader.load(url, (err) => {
      if (this.data.sprite !== spriteToLoad) {
        // you've already requested a different sprite
        return;
      }
      let texture;
      this.loading = false;
      this.events.emit("loaded");
      if (err) {
        console.error('error loading my sprite', err);
        texture = Loader.resources['__error'];
        this.renderTools.addError(this.transform, err);
      } else {
        texture = Loader.resources[url].texture;
      }

      const sprite = this.sprite
      if (!sprite) {
        console.warn('sprite lost for', url);
        return;
      }

      this.justLoaded(texture);
      sprite.texture = texture;
      this.currentImg = this.data.sprite;
      const textureWidth = texture.width;
      const textureHeight = texture.height;
      //sprite.scale.x =  this.renderTools.worldToScreen_x(textureWidth) * 16;
      //sprite.scale.y =  this.renderTools.worldToScreen_y(textureHeight) * 9;
      const unit = this.renderTools.worldToScreen({x:1, y:1});
      sprite.scale.x = unit.x / textureWidth;
      sprite.scale.y = unit.y / textureHeight;

      this.tilingSprite = makeTilingSprite(this.data, Loader.resources, this.transform.transform, 0.5, 0.5);
      moveTilingSprite(this.data, this.tilingSprite, {x:0,y:0}, this.width, this.height);
      this.sprite.visible = false;
      this.parentContainer.addChild(this.tilingSprite);

      //sprite.cacheAsBitmap = true;
    });
  } else {
    const spriteToLoad = this.data.texture;
    const tilesheet = this.data.atlas;
    const tilesheetUrl = this.renderTools.makeSpritesheetUrl(tilesheet);

    // Load placeholder.png here as a workaround for retarded pixi bug.
    // https://www.html5gamedevs.com/topic/19175-loader-progress-for-texture-atlas/
    // the loader normally will handle cases like this, and not hit 100% until all resources are loaded (including discovered files from atlases) but there is one exception to that rule: if you load *only* one single atlas.
    Loader.load(this.renderTools.makeImageUrl('placeholder.png'), () => {} );
    console.log('load', tilesheetUrl);
    Loader.load(tilesheetUrl, () => {
      console.log('lel');
      if (this.data.texture !== spriteToLoad) {
        // you've already requested a different sprite
        return;
      }

      //console.log('looking for', tilesheetUrl, Object.keys(Loader.resources));
      const textureAtlas = Loader.resources[tilesheetUrl];

      let texture = textureAtlas.textures[this.data.texture]

      this.justLoaded(texture);

      this.currentImg = this.data.texture;

      this.sprite.texture = texture;
      this.currentImg = this.data.texture;

      const textureWidth = texture.width;
      const textureHeight = texture.height;

      const unit = this.renderTools.worldToScreen({x:1, y:1});
      this.sprite.scale.x = unit.x / textureWidth;
      this.sprite.scale.y = unit.y / textureHeight

      this.loading = false;
      this.events.emit("loaded");

      console.log('make tiley');
      this.tilingTexture = texture;
      const {sprite,width,height} = makeTilingSprite(this.data, texture, this.transform.transform, 0.5, 0.5);
      this.width = width;
      this.height = height;

      this.shitContainer = new PIXI.Container();
      this.shitContainer.scale.set(unit.x/width, unit.y/height);
      this.shitContainer.addChild(sprite)

      this.tilingSprite = sprite;
      moveTilingSprite(this.data, this.tilingSprite, {x:0,y:0}, this.width, this.height);

      this.sprite.visible = false;
      this.parentContainer.addChild(this.shitContainer);

    });
  }
}

</script>
